/**
 * `"'true'"` — наследство: teamplay-user до 10.08.2026 слал метку в кавычках. Пока прод не выкатил
 * новый бэкенд, фронтенд обязан понимать оба варианта — иначе порядок выкатки становится ловушкой:
 * фронт вперёд бэка молча оставил бы OAuth-новичков без онбординга. Убрать, когда teamplay-user
 * на проде отдаёт `newUser=true`.
 */
const LEGACY_QUOTED_FLAG = "'true'";

/**
 * Разбор метки «аккаунт только что создан». Единственное место, где значение сравнивается —
 * проверка на «параметр вообще есть» уже дважды стоила нам инцидента: бэкенд слал
 * `newUser='false'` возвращающимся, а непустая строка истинна, и человек с полугодовым стажем
 * получал приветственный попап на каждом входе через Discord.
 *
 * Три вида значения — не небрежность. Переход внутри приложения кладёт в состояние строку,
 * разбор адреса (прямой заход, перезагрузка, редирект с бэкенда) отдаёт boolean, а прод до
 * выкатки отдаёт строку в кавычках.
 */
export const isNewUserFlag = (value: unknown) =>
  value === true || value === 'true' || value === LEGACY_QUOTED_FLAG;
